import React from "react";
import Agent from "./Agent";
import "./style.css";

const AiAgent = () => {
  return (
    <div className="ai-page">
      <div className="ai-tabcontent">
        <Agent />
      </div>
    </div>
  );
};

export default AiAgent;
